import type { GenericLanguages } from '@payloadcms/translations'

export const i18n: Partial<GenericLanguages> = {
  ar: {
    label: 'القاعدة الأفقية',
  },
  az: {
    label: 'Üfüqi Xətt',
  },
  bg: {
    label: 'Хоризонтална линия',
  },
  cs: {
    label: 'Vodorovný pravítko',
  },
  da: {
    label: 'Horisontal Regel',
  },
  de: {
    label: 'Trennlinie',
  },
  en: {
    label: 'Horizontal Rule',
  },
  es: {
    label: 'Regla Horizontal',
  },
  et: {
    label: 'Horisontaalne reegel',
  },
  fa: {
    label: 'قاعده افقی',
  },
  fr: {
    label: 'Règle horizontale',
  },
  he: {
    label: 'קו אופקי',
  },
  hr: {
    label: 'Vodoravna linija',
  },
  hu: {
    label: 'Vízszintes vonal',
  },
  is: {
    label: 'Lárétt lína',
  },
  it: {
    label: 'Regola Orizzontale',
  },
  ja: {
    label: '水平線',
  },
  ko: {
    label: '수평 규칙',
  },
  my: {
    label: 'Peraturan Mendatar',
  },
  nb: {
    label: 'Horisontal Regel',
  },
  nl: {
    label: 'Horizontale Regel',
  },
  pl: {
    label: 'Pozioma Linia',
  },
  pt: {
    label: 'Regra Horizontal',
  },
  ro: {
    label: 'Linie orizontală',
  },
  rs: {
    label: 'Хоризонтална линија',
  },
  'rs-latin': {
    label: 'Horizontalna linija',
  },
  ru: {
    label: 'Горизонтальная линия',
  },
  sk: {
    label: 'Vodorovná čiara',
  },
  sl: {
    label: 'Vodoravna črta',
  },
  sv: {
    label: 'Horisontell linje',
  },
  ta: {
    label: 'குறுக்கு வரி',
  },
  th: {
    label: 'เส้นขอบแนวนอน',
  },
  tr: {
    label: 'Yatay Çizgi',
  },
  uk: {
    label: 'Горизонтальна лінія',
  },
  vi: {
    label: 'Quy tắc ngang',
  },
  zh: {
    label: '水平线',
  },
  'zh-TW': {
    label: '水平線',
  },
}
